import axios from '../axios'

/**
 * 学时回退，查询培训阶段列表
 * @param {*} data
 * stuId	是	string	学员ID 
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12060112  20220622
 */
export const listTrainStageByStudent = data => {
  return axios({
    url: '/stu/stuBackList',
    method: 'post',
    data,
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/training.js